// removed by extract-text-webpack-plugin
module.exports = {"app":"_3sz-Jorbvi2LDO38TpQcMl","withSideMenu":"_2P7aVzcOZDvkxBQEYO7xgG","rainbow":"HZB3NKzYHhH24XAHwK3D-","header":"_3Ee_zvmheo5MP90PEzHqmK","content":"_1xM1AikmVov8veARQ3yrpP"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/App/App.scss
// module id = 1349
// module chunks = 1